import { DefaultButton, Label, TextField } from '@fluentui/react';
import React, { useState } from 'react';

import { requestStore } from 'src/stores';
import { revokeSfAccessToken } from 'src/v2/api/debug';
import { useStyles } from './RevokeAccessTokenButton.styles';

type Props = {
  token: string;
};

const SUCCESS_TIMEOUT = 5000;

function RevokeAccessTokenButton({ token }: Props) {
  const styles = useStyles();
  const [delay, setDelay] = useState('10');
  const [isFiring, setIsFiring] = useState(false);

  async function fire() {
    const seconds = Math.max(0, parseInt(delay, 10) || 0);
    setIsFiring(true);
    try {
      await revokeSfAccessToken(token, seconds);
      const revokedAt = new Date().toLocaleTimeString();
      console.log(`SF access_token revoked at ${revokedAt}`);
      requestStore.success(`SF access_token revoked at ${revokedAt}`, SUCCESS_TIMEOUT);
    } catch (error: any) {
      requestStore.raise(error?.message || 'Failed to revoke SF access_token');
    } finally {
      setIsFiring(false);
    }
  }

  const delaySeconds = parseInt(delay, 10) || 0;

  return (
    <div className={styles.root}>
      <Label>Revoke SF access_token (refresh_token stays valid)</Label>
      <div className={styles.row}>
        <TextField
          label='Delay (sec)'
          value={delay}
          onChange={(_e, value) => setDelay(value ?? '')}
          disabled={isFiring}
          className={styles.delayField}
        />
        <DefaultButton
          text={isFiring ? 'Revoking...' : delaySeconds > 0 ? `Revoke in ${delaySeconds}s` : 'Revoke now'}
          onClick={fire}
          disabled={isFiring}
        />
      </div>
    </div>
  );
}

export default RevokeAccessTokenButton;
